import { render } from "./Notification.vue?vue&type=template&id=6f814b92&scoped=true&ts=true"
import script from "./Notification.vue?vue&type=script&lang=ts"
export * from "./Notification.vue?vue&type=script&lang=ts"

import "./Notification.vue?vue&type=style&index=0&id=6f814b92&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src3320913318/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f814b92"]])

export default __exports__